import { useTheme } from '@mui/material/styles';

export const DefinitionCardSelectorStyles = () => {
    const theme = useTheme();
    return {
        "& .form-select": {
            background: "white"
        },
        "& .data-filters__item": {
            marginBottom: "5%",
            position: "relative", 
            padding: "10px", 
            background: theme.palette.purpleCold.light,
            borderBottom: "2px solid rgb(187 182 195)",
            boxShadow: "rgb(191, 183, 203) 0px 1px 2px"
        },
        "& .filter-district": {
            flexGrow: "2"
        }, 
        "& .close_icon": {
            position: "absolute",
            cursor: "pointer",
            marginTop: {
                xs: "5%",
                sm: "3%",
                md: "0"
            },
            left: { xs: "86%", sm: "90%" , md: "95%" },
            top: { md: "16%"}, 
        }
    }
}